<template>
  <el-row style="width: 100%;height: 375px;background-color: #eaf4f7;margin-top: 75px;">
    <el-row style="width: 68%;margin-left: 16%;height: calc(100% - 100px);border-bottom: 1px solid #000000;display: flex;">
      <el-col style="width: 39%;height: 100%;text-align: left;color: #000000;margin-left: 1%;">
        <el-row style="width: 100%;height: 40px;line-height: 40px;font-size: 28px;margin-top: 44px;">武汉瑜岿科技有限公司</el-row>
        <el-row style="width: 100%;height: 36px;line-height: 36px;font-size: 18px;">WUHAN YUKUI TECHNOLOGY CO.,LTD.</el-row>
        <el-row style="width: 100%;height: 26px;line-height: 26px;font-size: 14px;color: #5e5e5e;margin-top: 26px;">电话：17720560059（张经理）/18627018350（张经理）</el-row>
        <el-row style="width: 100%;height: 26px;line-height: 26px;font-size: 14px;color: #5e5e5e;">固话：027-87003315</el-row>
        <el-row style="width: 100%;height: 26px;line-height: 26px;font-size: 14px;color: #5e5e5e;">邮箱：yukuitech@163.com</el-row>
        <el-row style="width: 100%;height: 26px;line-height: 26px;font-size: 14px;color: #5e5e5e;">地址：武汉东湖新技术开发区东信路11号武汉留学生创业园C4196</el-row>
      </el-col>
      <el-col style="width: calc(20% - 40px);margin-left: 80px;margin-top: 64px;color: #696969;font-size: 16px;font-weight: bold;text-align: left;">
        <el-row style="width: 100%;height: 36px;margin-bottom: 24px;cursor: pointer;" @click.native="routeChange('/software', '311')">软件产品</el-row>
        <el-row style="width: 100%;height: 36px;margin-bottom: 24px;cursor: pointer;" @click.native="routeChange('/hardware', '321')">硬件产品</el-row>
        <el-row style="width: 100%;height: 36px;margin-bottom: 24px;cursor: pointer;" @click.native="routeChange('/solution', '411')">解决方案</el-row>
      </el-col>
      <el-col style="width: 10%;margin-top: 64px;color: #696969;font-size: 16px;font-weight: bold;text-align: left;">
        <el-row style="width: 100%;height: 36px;margin-bottom: 24px;cursor: pointer;" @click.native="routeChange('/short_introduce')">走进瑜岿</el-row>
        <el-row style="width: 100%;height: 36px;margin-bottom: 24px;cursor: pointer;" @click.native="routeChange('/news')">新闻资讯</el-row>
<!--        <el-row style="width: 100%;height: 36px;margin-bottom: 24px;cursor: pointer;">加入瑜岿</el-row>-->
<!--        <el-row style="width: 100%;height: 36px;margin-bottom: 24px;cursor: pointer;">联系我们</el-row>-->
      </el-col>
      <el-col style="width: calc(20% - 40px);margin-top:56px;color: #5e5e5e;font-size: 14px;">
        <el-row class="qrcode-img"></el-row>
        <el-row style="line-height: 30px;">扫码关注</el-row>
        <el-row style="line-height: 20px;">武汉瑜岿科技有限公司</el-row>
      </el-col>
      <el-col style="width: 10%;font-size: 16px;margin-top:56px;font-weight: bold;">
        <el-row style="width: 100%;height: 36px;margin-bottom: 24px;cursor: pointer;" @click.native="toOutside('http://www.sgcc.com.cn/')">国家电网</el-row>
        <el-row style="width: 100%;height: 36px;margin-bottom: 24px;cursor: pointer;" @click.native="toOutside('https://www.csg.cn/')">南方电网</el-row>
        <el-row style="width: 100%;height: 36px;margin-bottom: 24px;cursor: pointer;" @click.native="toOutside('http://www.nea.gov.cn/')">国家能源局</el-row>
      </el-col>
    </el-row>
    <el-row style="width: 70%;margin-left: 10%;height: 74px;margin-top: 26px;font-size: 14px;color: #696969;">
      © 2022-2024 武汉瑜岿科技有限公司版权所有
      <span style="cursor: pointer;margin-left: 10px;" @click.native="toIcpAddr">鄂ICP备2022007980号-1</span>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    toIcpAddr() {
      window.open('https://beian.miit.gov.cn/', '_blank')
    },
    routeChange(val, page) {
      if (this.$route.path !== val) {
        if (page) {
          this.$router.push({path: val, query: {page: page}})
        } else {
          this.$router.push(val)
        }
      } else {
        document.documentElement.scrollTop = 0
        location.reload()
      }
    },
    toOutside(url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
  .qrcode-img {
    background-image: url("../assets/img/qrcode.jpg");
    margin-left: 50px;
    width: 120px;
    height: 120px;
    background-size: cover;
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterPage.vue